<template>
  <div>
    <div>
      <classenv :data_pre="cla_env_pre" :data_pri="cla_env_pri" :preOnOff="preOnOff" :title="title[1]"/>
    </div>
    <div v-if="preOnOff === 1">
      <classpre :dmate="mate_pre" :title="title[2]"/>
    </div>
    <div>
      <classpri :data="mate_pri" :title="title[3]"/>
    </div>
    <div>
      <priempcont :data="sta_eect" :title="title[5]" />
    </div>
    <div v-if="preOnOff === 1">
      <preintoy :data="mat_toy" :title="title[4]"/>
    </div>
  </div>
</template>

<script>

import classEnvPri from '@/components/ascf/pri/classEnvPri.vue'
import classPre from '@/components/ascf/pri/classPre.vue'
import preInternalToy from '@/components/ascf/pre/preInternalToy.vue'
import classPri from '@/components/ascf/pri/classPri.vue'
import priEmpContract from "@/components/ascf/pri/priEmpContract.vue";

export default {
  props: ["title", "cla_env_pre", "cla_env_pri", "mate_pre", "mate_pri", "mat_toy", "sta_eect", "preOnOff"],
  components: {
    'classenv': classEnvPri,
    'classpre': classPre,
    'preintoy': preInternalToy,
    'classpri': classPri,
    priempcont: priEmpContract
  },
  data () {
    return {

    }
  }
}
</script>
<style scoped>

</style>